import { render, staticRenderFns } from "./deptList.vue?vue&type=template&id=e0aa4756&"
import script from "./deptList.vue?vue&type=script&lang=js&"
export * from "./deptList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports